<main>
    <csn-header></csn-header>

    <!-- Hero -->
    <section class="bg-dark pt-5" data-bs-theme="dark">
        <div class="container pb-2 py-lg-3">
            <nav class="py-3 mb-lg-3" aria-label="breadcrumb">
                <ol class="breadcrumb justify-content-center justify-content-lg-start mb-0">
                    <li class="breadcrumb-item">
                        <a routerLink="/"><i class="bx bx-home-alt fs-lg me-1"></i>Home</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Pricing</li>
                </ol>
            </nav>
            <h1 class="text-center mb-0">Simple, transparent pricing</h1>
            <p class="text-center text-light opacity-70 mt-2">Start free. Upgrade when you're ready.</p>
        </div>
        <div style="height: 300px;"></div>
    </section>

    <!-- Tier cards -->
    <section class="container position-relative zindex-2" style="margin-top: -300px;">

        <!-- Loading skeleton -->
        <div *ngIf="isLoading" class="d-flex justify-content-center py-5" aria-live="polite" aria-label="Loading plan information">
            <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading your plan&hellip;</span>
            </div>
        </div>

        <div *ngIf="!isLoading" class="row g-4 justify-content-center" role="list" aria-label="Pricing tiers">

            <!-- Free -->
            <div class="col-lg-4 col-md-6" role="listitem">
                <div class="card h-100 border shadow-sm position-relative"
                     [class.border-primary]="currentTier === 'free'"
                     [class.border-2]="currentTier === 'free'">
                    <span *ngIf="currentTier === 'free'"
                          class="badge bg-primary position-absolute top-0 start-50 translate-middle">
                        Your current plan
                    </span>
                    <div class="card-body text-center py-5">
                        <h2 class="h3 mb-1">Free</h2>
                        <p class="text-muted mb-4">Forever free — no credit card</p>
                        <div class="display-4 fw-bold mb-0">$0</div>
                        <div class="text-muted mb-5">&nbsp;</div>
                        <ul class="list-unstyled text-start mb-0">
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>1 course</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>3 AI sign generations total</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Low-res exports (watermarked)</li>
                            <li class="py-2 border-bottom"><i class="bx bx-x text-muted me-2" aria-hidden="true"></i>Custom branding</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>1 user</li>
                            <li class="py-2"><i class="bx bx-x text-muted me-2" aria-hidden="true"></i>Priority support</li>
                        </ul>
                    </div>
                    <div class="card-footer border-0 bg-transparent text-center pb-5">
                        <a routerLink="/signup"
                           class="btn btn-outline-primary btn-lg w-100"
                           [attr.aria-label]="'Get started with Free plan'">
                            Get started free
                        </a>
                    </div>
                </div>
            </div>

            <!-- Pro -->
            <div class="col-lg-4 col-md-6" role="listitem">
                <div class="card h-100 bg-primary text-white shadow-lg position-relative border-0">
                    <span *ngIf="currentTier === 'pro'"
                          class="badge bg-light text-primary position-absolute top-0 start-50 translate-middle">
                        Your current plan
                    </span>
                    <div class="card-body text-center py-5">
                        <h2 class="h3 mb-1 text-white">Pro</h2>
                        <p class="opacity-75 mb-4">One-time purchase per course</p>
                        <div class="display-4 fw-bold mb-0">$29</div>
                        <div class="opacity-75 mb-5">per course, one-time</div>
                        <ul class="list-unstyled text-start mb-0">
                            <li class="py-2 border-bottom border-light border-opacity-25">
                                <i class="bx bx-check me-2" aria-hidden="true"></i>1 course per purchase
                            </li>
                            <li class="py-2 border-bottom border-light border-opacity-25">
                                <i class="bx bx-check me-2" aria-hidden="true"></i>Unlimited AI sign generations
                            </li>
                            <li class="py-2 border-bottom border-light border-opacity-25">
                                <i class="bx bx-check me-2" aria-hidden="true"></i>Full-resolution exports
                            </li>
                            <li class="py-2 border-bottom border-light border-opacity-25">
                                <i class="bx bx-check me-2" aria-hidden="true"></i>Custom branding
                            </li>
                            <li class="py-2 border-bottom border-light border-opacity-25">
                                <i class="bx bx-check me-2" aria-hidden="true"></i>1 user
                            </li>
                            <li class="py-2">
                                <i class="bx bx-x opacity-50 me-2" aria-hidden="true"></i>Priority support
                            </li>
                        </ul>
                    </div>
                    <div class="card-footer border-0 bg-transparent text-center pb-5">
                        <button *ngIf="currentTier !== 'pro'"
                                class="btn btn-light btn-lg w-100"
                                [disabled]="checkoutLoading !== null"
                                (click)="startProCheckout()"
                                [attr.aria-label]="'Buy a course for $29 one-time'">
                            <span *ngIf="checkoutLoading !== 'pro'">Buy a course &mdash; $29</span>
                            <span *ngIf="checkoutLoading === 'pro'">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Redirecting&hellip;
                            </span>
                        </button>
                        <span *ngIf="currentTier === 'pro'"
                              class="badge bg-light text-primary fs-sm py-2 px-3">
                            Active plan
                        </span>
                    </div>
                </div>
            </div>

            <!-- Club -->
            <div class="col-lg-4 col-md-6" role="listitem">
                <div class="card h-100 border shadow-sm position-relative"
                     [class.border-primary]="currentTier === 'club'"
                     [class.border-2]="currentTier === 'club'">
                    <span *ngIf="currentTier === 'club'"
                          class="badge bg-primary position-absolute top-0 start-50 translate-middle">
                        Your current plan
                    </span>
                    <div class="card-body text-center py-5">
                        <h2 class="h3 mb-1">Club</h2>
                        <p class="text-muted mb-4">Best for multi-course clubs &amp; TDs</p>
                        <div class="display-4 fw-bold mb-0">$19</div>
                        <div class="text-muted mb-5">per month</div>
                        <ul class="list-unstyled text-start mb-0">
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Up to 10 courses</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Unlimited AI sign generations</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Full-resolution exports</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Custom branding</li>
                            <li class="py-2 border-bottom"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>5 users</li>
                            <li class="py-2"><i class="bx bx-check text-success me-2" aria-hidden="true"></i>Priority support</li>
                        </ul>
                    </div>
                    <div class="card-footer border-0 bg-transparent text-center pb-5">
                        <button *ngIf="currentTier !== 'club'"
                                class="btn btn-primary btn-lg w-100"
                                [disabled]="checkoutLoading !== null"
                                (click)="startClubCheckout()"
                                [attr.aria-label]="'Start Club plan for $19 per month'">
                            <span *ngIf="checkoutLoading !== 'club'">Start Club &mdash; $19/mo</span>
                            <span *ngIf="checkoutLoading === 'club'">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Redirecting&hellip;
                            </span>
                        </button>
                        <span *ngIf="currentTier === 'club'"
                              class="badge bg-primary fs-sm py-2 px-3">
                            Active plan
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Feature comparison table -->
    <section class="container py-5 my-md-4" aria-label="Feature comparison">
        <h2 class="text-center mb-5">Full feature comparison</h2>
        <div class="table-responsive">
            <table class="table table-bordered align-middle" aria-label="Compare Free, Pro, and Club features">
                <thead class="table-dark">
                    <tr>
                        <th scope="col">Feature</th>
                        <th scope="col" class="text-center">Free</th>
                        <th scope="col" class="text-center bg-primary text-white">Pro <small class="d-block fw-normal opacity-75">$29/course</small></th>
                        <th scope="col" class="text-center">Club <small class="d-block fw-normal text-muted">$19/mo</small></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Courses</th>
                        <td class="text-center">1</td>
                        <td class="text-center bg-primary bg-opacity-10">1 per purchase</td>
                        <td class="text-center">10</td>
                    </tr>
                    <tr class="table-light">
                        <th scope="row">AI sign generations</th>
                        <td class="text-center">3 total</td>
                        <td class="text-center bg-primary bg-opacity-10">Unlimited</td>
                        <td class="text-center">Unlimited</td>
                    </tr>
                    <tr>
                        <th scope="row">Export quality</th>
                        <td class="text-center">Low-res, watermarked</td>
                        <td class="text-center bg-primary bg-opacity-10">Full resolution</td>
                        <td class="text-center">Full resolution</td>
                    </tr>
                    <tr class="table-light">
                        <th scope="row">Custom branding</th>
                        <td class="text-center"><i class="bx bx-x lead text-muted" aria-label="Not included"></i></td>
                        <td class="text-center bg-primary bg-opacity-10"><i class="bx bx-check lead text-success" aria-label="Included"></i></td>
                        <td class="text-center"><i class="bx bx-check lead text-success" aria-label="Included"></i></td>
                    </tr>
                    <tr>
                        <th scope="row">Users</th>
                        <td class="text-center">1</td>
                        <td class="text-center bg-primary bg-opacity-10">1</td>
                        <td class="text-center">5</td>
                    </tr>
                    <tr class="table-light">
                        <th scope="row">Priority support</th>
                        <td class="text-center"><i class="bx bx-x lead text-muted" aria-label="Not included"></i></td>
                        <td class="text-center bg-primary bg-opacity-10"><i class="bx bx-x lead text-muted" aria-label="Not included"></i></td>
                        <td class="text-center"><i class="bx bx-check lead text-success" aria-label="Included"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</main>

<csn-footer></csn-footer>
